/**
 * Ad Telemetry Client
 * Handles the reliable dispatch of advertising events to the SURGEDOME ingestion endpoint.
 */

// In-memory set to prevent duplicate event dispatches within the same session
const dispatchedEvents = new Set();

export function trackAdEvent(trackingToken, eventType) {
  if (!trackingToken || !eventType) return;

  const eventKey = `${trackingToken}:${eventType}`;

  // Prevent duplicate events per decision
  if (dispatchedEvents.has(eventKey)) {
    return;
  }

  dispatchedEvents.add(eventKey);

  try {
    const payload = JSON.stringify({
      trackingToken,
      eventType: eventType
    });

    // Fire and forget via beacon if available, otherwise fetch
    if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
      const body = typeof Blob === 'undefined' ? payload : new Blob([payload], { type: 'application/json' });
      navigator.sendBeacon('/api/ads/track', body);
    } else if (typeof fetch !== 'undefined') {
      fetch('/api/ads/track', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: payload,
        keepalive: true
      }).catch(() => {
        // Fail silently - analytics must never block ad rendering
      });
    }
  } catch (error) {
    // Analytics failure must never prevent an advertisement from rendering
    console.error('Ad telemetry failed:', error);
  }
}
